import React from "react";
import Navbar from "../NavBar";
import Packages from "./Packages";
import Footer from "../Footer";

export default function CountryPage() {
  return (
    <>
      <Navbar border="true" />
      <Packages />
      <Footer />
    </>
  );
}
